import { SET_ERROR } from "../App/constants";
import {
  ACTION_COMPLETE_PRICING_UPLOAD,
  ACTION_DOWNLOAD_PRICING,
  ACTION_DOWNLOAD_PRICING_STARTED,
  ACTION_LOAD_PRICING,
  ACTION_PRICING_LOADED,
  ACTION_PRICING_SAVED,
  ACTION_SAVE_PRICING,
  ACTION_UPLOAD_PRICING,
  ACTION_UPLOAD_PRICING_FAILED,
  ACTION_UPLOAD_PRICING_SUCCEEDED,
} from "./constants";
import PricingPageState, { ImportExportPricingState } from "./state";

export const importExportPricingInitialState: ImportExportPricingState = {
  type: "initial",
  loading: false,
  pricingItems: [],
  downloading: false,
};

export const initialState: PricingPageState = {
  importExportPricingState: importExportPricingInitialState,
};

export const importExportPricingReducer = (
  state: ImportExportPricingState = importExportPricingInitialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): ImportExportPricingState => {
  switch (action.type) {
    case ACTION_LOAD_PRICING:
      if (state.type === "initial") {
        return {
          ...state,
          loading: true,
          pricingItems: [],
        };
      }
      return state;

    case ACTION_PRICING_LOADED:
      if (state.type === "initial") {
        return {
          ...state,
          loading: false,
          pricingItems: action.pricingItems,
        };
      }
      return state;

    case ACTION_DOWNLOAD_PRICING:
      if (state.type === "initial") {
        return {
          ...state,
          downloading: true,
        };
      }
      return state;

    case ACTION_DOWNLOAD_PRICING_STARTED:
      if (state.type === "initial") {
        return {
          ...state,
          downloading: false,
        };
      }
      return state;

    case ACTION_UPLOAD_PRICING:
      return {
        type: "uploading",
      };

    case ACTION_UPLOAD_PRICING_SUCCEEDED:
      return {
        type: "upload-succeeded",
        pricingItems: action.pricingItems,
        pricingImportId: action.pricingImportId,
      };

    case ACTION_UPLOAD_PRICING_FAILED:
      return {
        type: "upload-failed",
        errors: action.errors,
      };

    case ACTION_COMPLETE_PRICING_UPLOAD:
      return importExportPricingInitialState;

    case ACTION_SAVE_PRICING:
      return {
        type: "saving",
        totalCount:
          state.type == "upload-succeeded" ? state.pricingItems.length : 0,
      };

    case ACTION_PRICING_SAVED:
      return {
        type: "saved",
        totalCount: state.type == "saving" ? state.totalCount : 0,
      };

    case SET_ERROR: {
      return importExportPricingInitialState;
    }

    default:
      break;
  }

  return state;
};
